
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/measure/projects",
      function () {
        return require("private-next-pages/measure/projects.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/measure/projects"])
      });
    }
  